'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  padded?: boolean;
  hoverable?: boolean;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ padded = true, hoverable = false, className, children, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'bg-surface-2 border border-border-subtle rounded-md',
          padded && 'p-4',
          hoverable && 'cursor-pointer hover:bg-surface-3 transition-colors duration-150',
          className
        )}
        {...rest}
      >
        {children}
      </div>
    );
  }
);
Card.displayName = 'DsCard';
